import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query-v5';
import api from '../api';
import { PowerBiReportDto, PowerBiReportListDto } from '../api-client';
import { QueryKey } from '../enums';

interface UseGetOrganizationPowerBiReportsPayload {
  organizationId?: string;
  options?: Omit<UseQueryOptions<PowerBiReportListDto>, 'queryKey'>;
}

export const useGetOrganizationPowerBiReports = ({
  organizationId = '',
  options,
}: UseGetOrganizationPowerBiReportsPayload): UseQueryResult<PowerBiReportListDto> =>
  useQuery({
    queryKey: [
      QueryKey.Resource.PowerBiOrganizationReports,
      QueryKey.Operation.List,
      organizationId,
    ],
    queryFn: async () =>
      api.organizations.powerBiReportsControllerGetPowerBiReports(
        organizationId
      ) as Promise<PowerBiReportListDto>,
    staleTime: 0,
    enabled: !!organizationId && options?.enabled !== false,
    ...options,
  });

interface UseGetSingleOrganizationPowerBiReportPayload {
  organizationId?: string;
  reportId?: string;
}

export const useGetSingleOrganizationPowerBiReport = (
  options?: UseMutationOptions<
    PowerBiReportDto,
    Error,
    UseGetSingleOrganizationPowerBiReportPayload
  >
) =>
  useMutation({
    ...options,
    mutationKey: [
      QueryKey.Resource.PowerBiOrganizationReports,
      QueryKey.Operation.One,
    ],
    mutationFn: async ({
      reportId = '',
      organizationId = '',
    }: UseGetSingleOrganizationPowerBiReportPayload) =>
      await api.organizations.powerBiReportsControllerGetPowerBiReport(
        organizationId,
        reportId
      ),
  });
